import Vue from 'vue'
import { QUESTIONS } from '@/api'
import errorHandling from './exceptions'

/**
 * Retorna uma collection de perguntas com base
 * nos parâmetros informados.
 *
 * @param {object}   params
 * @param {function} callback
 */
const index = (params, callback) => {
  Vue.axios.get(QUESTIONS, { params })
    .then(res => {
      if (typeof res.data.meta !== 'undefined') {
        callback(res.data.questions, res.data.meta.pagination)
      } else {
        callback(res.data.questions)
      }
    })
    .catch(errorHandling)
}

/**
 * Alias para o método 'index' com o parâmetro
 * 'search_term' já embutido.
 *
 * @param {string}   term
 * @param {function} callback
 */
const search = (term, callback) => {
  index({ search_term: term }, callback)
}

/**
 * Retorna os detalhes de um pergunta com base
 * em sua ID.
 *
 * @param {integer}  id
 * @param {function} callback
 */
const show = (id, callback) => {
  Vue.axios.get(QUESTIONS + '/' + id)
    .then(res => {
      callback(res.data)
    })
    .catch(errorHandling)
}

/**
 * Salva os dados de um novo pergunta.
 *
 * @param {object}   data
 * @param {function} callback
 * @param {function} errorCallback
 */
const store = (data, callback, errorCallback) => {
  Vue.axios.post(QUESTIONS, data)
    .then(res => {
      callback(res.data)
    })
    .catch(errorCallback)
}

/**
 * Atualiza os dados de um pergunta.
 *
 * @param {integer}  id
 * @param {object}   data
 * @param {function} callback
 * @param {function} errorCallback
 */
const update = (id, data, callback, errorCallback) => {
  Vue.axios.put(QUESTIONS + '/' + id, data)
    .then(res => {
      callback(res.data)
    })
    .catch(errorCallback)
}

/**
 * Remove um pergunta com base em sua ID.
 *
 * @param {integer}  id
 * @param {function} callback
 */
const destroy = (id, callback) => {
  Vue.axios.delete(QUESTIONS + '/' + id)
    .then(callback)
    .catch(errorHandling)
}

export default {
  index,
  search,
  show,
  store,
  update,
  destroy
}
